import React, { useState, useCallback } from 'react';
import { Input, Popup, Button, Dropdown, Icon } from 'semantic-ui-react';

const SearchReplaceControls = ({
  searchOptions,
  viewOptions,
  handleSearch,
  handleClearFilter,
  handleAddNew,
  handleViewChange,
  renderFileStats
}) => {
  const [localSearchQuery, setLocalSearchQuery] = useState('');
  const [localReplaceQuery, setLocalReplaceQuery] = useState('');
  const [localSearchItem, setLocalSearchItem] = useState('All');
  const [localView, setLocalView] = useState('editor');

  const onSearchChange = useCallback((e) => setLocalSearchQuery(e.target.value), []);
  const onReplaceChange = useCallback((e) => setLocalReplaceQuery(e.target.value), []);
  const onSearchItemChange = useCallback((e, { value }) => setLocalSearchItem(value), []);
  const onViewChange = useCallback((e, { value }) => {
    setLocalView(value);
    handleViewChange(value); // Notify parent of view change
  }, [handleViewChange]);

  const onSearchAndReplaceClick = () => {
    console.log('SearchReplaceControls search now', localSearchQuery, 'searchItem', localSearchItem);
    handleSearch(localSearchQuery, localReplaceQuery, localSearchItem);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onSearchAndReplaceClick();
    }
  };

  const onHandleClearFilter = () => {
    setLocalSearchQuery('');
    setLocalReplaceQuery('');
    setLocalSearchItem('All');
    handleClearFilter();
  }

  return (
    <div className="search-container">
      <div className="search-replace-container" >
        <Input
          type="text"
          placeholder="Search..."
          value={localSearchQuery}
          onChange={onSearchChange}
          onKeyDown={handleKeyDown}
          className="search-input"
        />
        <Popup
          on="hover"
          content={<div>Search fields, or search and replace...</div>}
          trigger={
            <Dropdown
              compact
              selection
              options={searchOptions}
              placeholder="All"
              value={localSearchItem}
              onChange={onSearchItemChange}
              className="view-dropdown"
            />
          }
        />
        <Input
          type="text"
          placeholder="Replace with..."
          value={localReplaceQuery}
          onChange={onReplaceChange}
          className="replace-input"
        />
      </div>
      <div className="search-control-container">
        <Popup
          on="hover"
          content={<div>Search fields, or search and replace...</div>}
          trigger={<Button basic color="blue" onClick={onSearchAndReplaceClick}>Search & Replace</Button>}
        />
        <Button circular icon='close' color="blue" onClick={onHandleClearFilter} />
        <Popup
          on="hover"
          header={<span>New Story Element</span>}
          trigger={<Button basic color="green" onClick={handleAddNew}>Add</Button>}
        />
        <Dropdown
          compact
          selection
          options={viewOptions}
          value={localView}
          onChange={onViewChange}
          className="view-dropdown"
        />
        <Popup
          on="click"
          position="top left"
          wide="very"
          content={renderFileStats}
          className="story-stats-popup"
          trigger={<Icon className='file-stats-popup' inverted circular color='olive' name='info' />}
        />
      </div>
    </div>
  );
};

export default SearchReplaceControls;
